import React, {FC, useEffect, useState} from 'react';
import {
  CheckboxWrapper,
  CheckboxFilledSquare,
  CheckboxFilledLabel,
} from './Checkbox.styles';

export interface CheckboxProps {
  id: string;
  name?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (e: any) => void;
  testID?: string;
  label?: string;
  value?: string;
  checkboxSquareWidth?: number;
  checkboxSquareHeight?: number;
  checkMarkPosTop?: number;
  checkMarkPosRight?: number;
  marginBetweenLabel?: number;
  labelColor?: string;
  labelFontSize?: string;
  error?: string;
  labelWidth?: number;
  alignCenter?: boolean;
  squareColor?: string;
  className?: string;
  disabled?: boolean;
}

export interface StyledCheckboxProps {
  active?: boolean;
  checkboxSquareWidth?: number | undefined;
  checkboxSquareHeight?: number | undefined;
  checkMarkPosTop?: number | undefined;
  checkMarkPosRight?: number | undefined;
  marginBetweenLabel?: number | undefined;
  label?: string | undefined;
  labelColor?: string | undefined;
  labelFontSize?: string | undefined;
  error?: string | undefined;
  labelWidth?: number | undefined;
  alignCenter?: boolean;
  squareColor?: string;
  disabled?: boolean;
}

const Checkbox: FC<CheckboxProps> = ({
  id,
  name,
  defaultChecked,
  checked,
  onChange,
  label,
  value,
  checkboxSquareHeight,
  checkboxSquareWidth,
  checkMarkPosRight,
  checkMarkPosTop,
  marginBetweenLabel,
  labelColor,
  labelFontSize,
  error,
  labelWidth,
  alignCenter = true,
  squareColor,
  testID,
  className,
  disabled,
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const onChangeInternal: any = (e: React.MouseEventHandler<HTMLLabelElement>) => {
    setIsChecked(!isChecked);
    if (onChange) onChange(e);
  };

  return (
    <>
      <CheckboxWrapper
        className={className}
        alignCenter={alignCenter}
        disabled={disabled}
        onClick={e => e.stopPropagation()}>
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={isChecked}
          defaultChecked={defaultChecked}
          data-testid={testID}
          onChange={onChangeInternal}
          disabled={disabled}
          value={value}
          style={{display: 'none'}}
        />
        <CheckboxFilledSquare
          onChange={onChangeInternal}
          active={isChecked}
          checkboxSquareHeight={checkboxSquareHeight}
          checkboxSquareWidth={checkboxSquareWidth}
          checkMarkPosRight={checkMarkPosRight}
          checkMarkPosTop={checkMarkPosTop}
          marginBetweenLabel={marginBetweenLabel}
          squareColor={squareColor}
          error={error}
          label={label}
        />
        {!!label && (
          <CheckboxFilledLabel
            labelColor={labelColor}
            labelFontSize={labelFontSize}
            labelWidth={labelWidth}
            active={isChecked}>
            {label}
          </CheckboxFilledLabel>
        )}
      </CheckboxWrapper>
    </>
  );
};

export default Checkbox;
